import { useState, useEffect, useRef } from "react";
import axios from "axios";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useLocation, useNavigate } from "react-router-dom";
import doctorIcon from "./../../assets/images/icons/doctor.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/bundle";
import { Navigation } from "swiper/modules";
import StepBreadcrumb from "./step-breadcrumb";
import IsLogin from "../../utilities/functions/isLogin";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { Badge, TextField } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Switch from "@mui/material/Switch";
// import Stack from "@mui/material/Stack";
// import Typography from "@mui/material/Typography";
import FloatTitleCard from "../../components/cards/floatTitleCard";
import convertJalaliToMiladi from "../../utilities/functions/convertJalaliToMiladi";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/userSlice";
import ShareLinkModal from "../../components/modals/share/shareModal";
import haveAccess from "../../utilities/functions/haveAccess";
import convertSecondsToMinutesAndSeconds from "../../utilities/functions/convertSecondsToMinutesAndSeconds";
import BookingSkt from "../../components/Skeletons/BookingSkt";

// const MaterialUISwitch = styled(Switch)(({ theme }) => ({
//   width: 300, // Adjust the width according to your text length
//   height: 36,
//   paddingLeft: 7,
//   paddingLeft: 7,
//   paddingTop: 0,
//   paddingBottom: 0,
//   margin: 0,
//   "& .MuiSwitch-switchBase": {
//     margin: 4,
//     padding: 0,
//     transform: "translateX(7px)",
//     "&.Mui-checked": {
//       color: "#fff",
//       transform: "translateX(114px)", // Adjust the translation according to your text length
//       "& .MuiSwitch-thumb:before": {
//         content: '"برای خودم"',
//       },
//       "& + .MuiSwitch-track": {
//         opacity: 1,
//         backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#E9ECEF",
//       },
//     },
//     "&:not(.Mui-checked) .MuiSwitch-thumb:before": {
//       content: '"برای دیگری"',
//     },
//   },
//   "& .MuiSwitch-thumb": {
//     backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#0360D9",
//     width: 166,
//     height: 28,
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     position: "relative",
//     fontSize: "14px",
//     color: "#fff",
//     borderRadius: 50,
//     // margin: 0,
//   },
//   "& .MuiSwitch-track": {
//     opacity: 1,
//     backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#E9ECEF",
//     borderRadius: 100 / 2,
//   },
// }));

const ActiveTimesByPlace = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { search } = useLocation();

    const timer = useRef(null)

    const [initialLoading, setInitialLoading] = useState(true)

    const { token, roles } = useSelector((state) => state.user);
    const isMobile = window.innerWidth >= 992 ? false : true;

    const tokenLocal = localStorage.getItem("token");
    let headers = { Authorization: "Bearer " + token };

    const [loading, setLoading] = useState(true);
    const [loggedIn, setLoggedIn] = useState();
    const [verifyHeaders, setVerifyHeaders] = useState({ Authorization: "Bearer " + null });

    const queryParams = new URLSearchParams(search);
    const pl = queryParams.get("pl") ? queryParams.get("pl") : null;
    const dep = queryParams.get("dep") ? queryParams.get("dep") : null;
    const dr = queryParams.get("dr") ? queryParams.get("dr") : null;
    const action = queryParams.get("action") ? queryParams.get("action") : null;

    const [placeName, setPlaceName] = useState("");
    const [departmentName, setDepartmentName] = useState("");

    const [doctorTitle, setDoctorTitle] = useState("");
    const [doctorFirstName, setDoctorFirstName] = useState("");
    const [doctorLastName, setDoctorLastName] = useState("");
    const [doctorFile, setDoctorFile] = useState();
    const [doctorLastDegree, setDoctorLastDegree] = useState();

    const [doctorTotalAmount, setDoctorTotalAmount] = useState(null)
    const [doctorDepositAmount, setDoctorDepositAmount] = useState(null)

    const [address, setAddress] = useState("");

    const [doctorPhonenumber, setDoctorPhonenumber] = useState("");

    const [city, setCity] = useState("");
    const [province, setProvince] = useState("");

    const [forMe, setForMe] = useState(true);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const [guestfirstName, setGuestFirstName] = useState("");
    const [guestlastName, setGuestLastName] = useState("");
    const [guestphoneNumber, setGuestPhoneNumber] = useState("");

    const [guestfirstNameError, setGuestFirstNameError] = useState(null);
    const [guestlastNameError, setGuestLastNameError] = useState(null);
    const [guestphoneNumberError, setGuestPhoneNumberError] = useState(null);
    const [dateTimeError, setDateTimeError] = useState(null);

    const [days, setDays] = useState();
    const [activeTimesStatus, setActiveTimesStatus] = useState();
    const [activeTimes, setActiveTimes] = useState();
    const [activeFiveTimes, setActiveFiveTimes] = useState();

    // 1402/02/01
    const [selectedDay, setSelectedDay] = useState("");
    // 09:45
    const [selectedHour, setSelectedHour] = useState("");

    // // 1402/02/01
    // const [selectedOtherDay, setSelectedOtherDay] = useState("");
    // // 09:45
    // const [selectedOtherHour, setSelectedOtherHour] = useState("");

    // morning - evening - night
    const [shift, setShift] = useState(0);

    // 15:30
    const [hours, setHours] = useState();

    const [selectedOption, setSelectedOption] = useState(0);

    // #region edit Department Place
    const [modal_VerifyShow, setModal_VerifyShow] = useState(false);
    const [modal_VerifyInfo, setModal_VerifyInfo] = useState({ code: "", eventId: null, token: null });
    const [resendTimer, setResendTimer] = useState(900); // Initial timer value in seconds

    const delayedLoading = () => {
        clearTimeout(timer)
        setTimeout(() => setLoading(false), 0);
        clearTimeout(timer)
    }

    // #endregion

    const storeEventParameterAPI = () => {

        setLoading(true);

        axios
            .post(
                serverConfig.server.url + apiConfig.api.publicAPIs.eventInfo,
                {
                    doctor_id: dr,
                    department_id: dep,
                    place_id: pl,
                },
                { headers }
            )
            .then((response) => {
                if (response.data.status === "success") {
                    setDoctorTitle(response.data.data.doctor_title);
                    setDoctorFirstName(response.data.data.doctor_first_name);
                    setDoctorLastName(response.data.data.doctor_last_name);
                    setDoctorFile(response.data.data.doctor_file);
                    setDoctorLastDegree(response.data.data.last_degree);
                    setDoctorTotalAmount(response.data.data.total_visit_amount)
                    setDoctorDepositAmount(response.data.data.deposit_amount)
                    setDepartmentName(response.data.data.department_name);
                    setPlaceName(response.data.data.place_name);
                    setAddress(response.data.data.address);
                    setDoctorPhonenumber(response.data.data.phone);
                    setProvince(response.data.data.province);
                    setCity(response.data.data.city);
                } else {
                    if (response.data.code == 404 || response.data.code == 403) {
                        navigate("/404");
                    } else if (typeof response.data.errors === typeof "string") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => { toast.error("Error making API call:", error) })
            .finally(delayedLoading)
    };

    const getUserInfo = () => {

        setLoading(true);

        axios
            .get(
                serverConfig.server.url + apiConfig.api.userControllers.getUserInfo,
                {
                    headers,
                }
            )
            .then((response) => {
                if (response.data.status === "success") {
                    setFirstName(response.data.data.first_name);
                    setLastName(response.data.data.last_name);
                    setPhoneNumber(response.data.data.mobile);
                } else {
                    if (response.data.code == 404) {
                        navigate("/404");
                    } else if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => { toast.error("Error making API call:", error) })
            .finally(delayedLoading)
    };

    const StoreData = () => {
        if (validateFields()) {
            if (selectedDay && selectedHour) {
                setLoading(true);
                axios
                    .post(
                        serverConfig.server.url + apiConfig.api.publicAPIs.setEvent,
                        {
                            doctor_id: dr,
                            place_id: pl,
                            department_id: dep,
                            first_name: forMe ? firstName : guestfirstName,
                            last_name: forMe ? lastName : guestlastName,
                            mobile: forMe ? phoneNumber : guestphoneNumber,
                            start: convertJalaliToMiladi(selectedDay) + " " + selectedHour,
                            type: "in_person",
                        },
                        localStorage.getItem("token") && { headers }
                    )
                    .then((response) => {
                        if (response.data.status === "success") {
                            toast.success(response.data.message);
                            if (
                                response.data.data.event_id &&
                                !forMe &&
                                !haveAccess(roles, "setEvent_without_verification")
                            ) {
                                response.data.data.verification_code
                                    ? toast.success(
                                        "کد ارسال شده " + response.data.data.verification_code
                                    )
                                    : toast.success(
                                        "کد تایید نوبت به موبایل " +
                                        guestphoneNumber +
                                        " ارسال شد"
                                    );
                                if (token) {
                                    setVerifyHeaders({
                                        Authorization: "Bearer " + token,
                                    });
                                    setModal_VerifyInfo({
                                        code: "",
                                        eventId: response.data.data.event_id,
                                        token: token,
                                    });
                                } else {
                                    headers = {
                                        Authorization: "Bearer " + response.data.data.token,
                                    };

                                    setVerifyHeaders({
                                        Authorization: "Bearer " + response.data.data.token,
                                    });
                                    setModal_VerifyInfo({
                                        code: "",
                                        eventId: response.data.data.event_id,
                                        token: response.data.data.token,
                                    });
                                }
                                setResendTimer(900);
                                setModal_VerifyShow(true);
                            } else {
                                navigate(`/turn?id=${response.data.data.event_id}`);
                            }
                        } else {
                            if (typeof response.data.errors === typeof "String") {
                                toast.error(response.data.errors);
                            } else {
                                response.data.errors.forEach((element) => {
                                    toast.error(element);
                                });
                            }
                        }
                    })
                    .catch((error) => { toast.error("Error making API call:", error) })
                    .finally(delayedLoading)
            }
        }
    };

    // #region send SMS Code
    const Verify = () => {
        if (
            modal_VerifyInfo.code &&
            modal_VerifyInfo.eventId &&
            selectedHour &&
            selectedDay
        ) {

            setLoading(true);

            headers = verifyHeaders;

            axios
                .post(
                    serverConfig.server.url +
                    apiConfig.api.publicAPIs.confirmEvent +
                    "/" +
                    modal_VerifyInfo.eventId,
                    {
                        verification_code: modal_VerifyInfo.code,
                    },
                    { headers }
                )
                .then((response) => {
                    if (response.data.status === "success") {
                        toast.success(response.data.message);
                        !token && localStorage.setItem("token", response.data.data.token);
                        !token &&
                            dispatch(
                                setUser({
                                    token: response.data.data.token,
                                })
                            );

                        window.location.replace(`/turn?id=${modal_VerifyInfo.eventId}`);
                    } else {
                        if (typeof response.data.errors === typeof "String") {
                            toast.error(response.data.errors);
                        } else {
                            response.data.errors.forEach((element) => {
                                toast.error(element);
                            });
                        }
                    }
                })
                .catch((error) => { toast.error("Error making API call:", error) })
                .finally(delayedLoading)
        }
    };
    // #endregion

    // #region calendar
    const getMonthlyScheduleAPI = () => {

        setLoading(true);

        axios
            .post(
                serverConfig.server.url + apiConfig.api.publicAPIs.getMonthlySchedule,
                {
                    user_id: dr,
                    place_id: pl,
                    department_id: dep,
                },
                { headers }
            )
            .then((response) => {
                if (response.data.status === "success") {
                    if (response.data.data.monthly_schedule) {
                        let monthly_schedule = response.data.data.monthly_schedule;
                        setDays(response.data.data.days);

                        setActiveTimesStatus(splitScheduleStatus(monthly_schedule));
                        setActiveTimes(splitSchedule(monthly_schedule));

                        const firstDate = Object.keys(monthly_schedule)[0];
                        setSelectedDay(firstDate);
                    }
                    if (response.data.data.four_empty_turns) {
                        let four_time = response.data.data.four_empty_turns;
                        setActiveFiveTimes(four_time);
                        setSelectedHour(four_time[1].time);
                        setSelectedDay(four_time[1].date);
                    }
                } else {
                    if (response.data.code == 400) {
                        navigate("/404");
                    } else if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => { toast.error("Error making API call:", error) })
            .finally(delayedLoading)
    };

    const splitScheduleStatus = (schedule) => {
        const newSchedule = { ...schedule };
        for (const date in newSchedule) {
            if (newSchedule[date] != "تکمیل") {
                const hours = newSchedule[date];

                // Filter the array based on the second element of each sub-array
                const filteredTimes = hours
                    .filter(([time, include]) => include == 1 || include == 0)
                    .map(([time, include]) => [time, include]);

                const morning = filteredTimes.filter(([time, include]) => {
                    const [hours, minutes, seconds] = time.split(":").map(Number);
                    return [hours < 12, include];
                });

                const evening = filteredTimes.filter(([time, include]) => {
                    const [hours, minutes, seconds] = time.split(":").map(Number);
                    return [hours >= 12 && hours < 18, include];
                });

                const night = filteredTimes.filter(([time, include]) => {
                    const [hours, minutes, seconds] = time.split(":").map(Number);
                    return [
                        hours >= 18 || (hours == 0 && minutes == 0 && seconds == 0),
                        include,
                    ];
                });

                newSchedule[date] = {
                    morning,
                    evening,
                    night,
                };
            }
        }
        return newSchedule;
    };

    const splitSchedule = (schedule) => {
        const newSchedule = { ...schedule };
        for (const date in newSchedule) {
            if (newSchedule[date] != "تکمیل") {
                const hours = newSchedule[date];

                // Filter the array based on the second element of each sub-array
                const filteredTimes = hours
                    .filter(([time, include]) => include == 0) // include === 1 || include === 0 for both filled and free times
                    .map(([time]) => time);

                const morning = filteredTimes.filter((time) => {
                    const [hours, minutes, seconds] = time.split(":").map(Number);
                    return hours < 12;
                });

                const evening = filteredTimes.filter((time) => {
                    const [hours, minutes, seconds] = time.split(":").map(Number);
                    return hours >= 12 && hours < 18;
                });

                const night = filteredTimes.filter((time) => {
                    const [hours, minutes, seconds] = time.split(":").map(Number);
                    return hours >= 18 || (hours == 0 && minutes == 0 && seconds == 0);
                });

                newSchedule[date] = {
                    morning,
                    evening,
                    night,
                };
            }
        }

        return newSchedule;
    };

    const isActive = (shift, hours) => {
        if (
            shift === 0 &&
            activeTimesStatus[selectedDay] &&
            activeTimesStatus[selectedDay].morning &&
            activeTimesStatus[selectedDay].morning[hours] &&
            activeTimesStatus[selectedDay].morning[hours][1] === 1
        ) {
            return true;
        } else if (
            shift === 1 &&
            activeTimesStatus[selectedDay] &&
            activeTimesStatus[selectedDay].evening &&
            activeTimesStatus[selectedDay].evening[hours] &&
            activeTimesStatus[selectedDay].evening[hours][1] === 1
        ) {
            return true;
        } else if (
            shift === 2 &&
            activeTimesStatus[selectedDay] &&
            activeTimesStatus[selectedDay].night &&
            activeTimesStatus[selectedDay].night[hours] &&
            activeTimesStatus[selectedDay].night[hours][1] === 1
        ) {
            return true;
        } else return false;
    };

    const handleChangeHour = (hour) => {
        setSelectedHour(hour);
    };

    // const handleChangeOtherHour = (hour) => {
    //   setSelectedOtherHour(hour);
    // };

    const handleChangeDay = (day) => {
        setSelectedDay(day);
        setSelectedHour("");
    };

    // const handleChangeOtherDay = (day) => {
    //   setSelectedOtherDay(day);
    //   setSelectedOtherHour("");
    // };

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };
    // #endregion calendar

    // Switch Selector
    const changeForMe = (e) => {
        setForMe(e);
    };

    const changeFirstName = (firstName) => {
        setGuestFirstName(firstName);
        setGuestFirstNameError(null); // Clear the error when the user starts typing
    };
    const changeLastName = (lastName) => {
        setGuestLastName(lastName);
        setGuestLastNameError(null); // Clear the error when the user starts typing
    };
    const changePhoneNumber = (phoneNumber) => {
        setGuestPhoneNumber(phoneNumber);
        setGuestPhoneNumberError(null); // Clear the error when the user starts typing
    };

    const isShiftAvailable = (shift) => {
        if (!activeTimes || !selectedDay) return
        return Boolean(activeTimes[selectedDay]?.[shift]?.length)
    }

    const validateFields = () => {
        let isValid = true;

        if (!guestfirstName && !forMe) {
            setGuestFirstNameError("نام را وارد کنید");
            isValid = false;
        } else {
            setGuestFirstNameError(null);
        }

        if (!guestlastName && !forMe) {
            setGuestLastNameError("نام خانوادگی را وارد کنید");
            isValid = false;
        } else {
            setGuestLastNameError(null);
        }

        if (!guestphoneNumber && !forMe) {
            setGuestPhoneNumberError("شماره همراه را وارد کنید");
            isValid = false;
        } else {
            setGuestPhoneNumberError(null);
        }

        if (!selectedDay && !selectedHour) {
            setDateTimeError("زمان ویزیت را انتخاب کنید");
            isValid = false;
        } else {
            setDateTimeError(null);
        }

        return isValid;
    };

    useEffect(() => {
        !modal_VerifyShow &&
            setModal_VerifyInfo({
                code: "",
                eventId: null,
                token: null,
            });
    }, [modal_VerifyShow]);

    useEffect(() => {

        const shiftsList = ['morning', 'evening', 'night']

        if (selectedDay && activeTimes[selectedDay]) {

            const hoursList = activeTimes[selectedDay][shiftsList[shift]]

            if (!hoursList?.length) {

                shiftsList.splice(shift, 1) // remove the not available shift

                // if user choose shift 0(صبح) and then change the selected day and in that day the shift(0) is not available, it automaticly change the shift to an available shift and update the hours btw.
                shiftsList.some(shift => {

                    let availableShift = activeTimes[selectedDay]?.[shift]

                    if (availableShift?.length) {
                        setHours(availableShift)
                        setShift(shiftsList.indexOf(shift))
                        return true
                    }

                })
            }

            setHours(activeTimes[selectedDay][shiftsList[shift]])
        }

    }, [shift, selectedDay]);

    useEffect(() => {
        const checkLoginStatus = async () => {
            try {
                const result = await IsLogin(); // Call IsLogin function
                setLoggedIn(result); // Update loggedIn state with the result

                if (result === false || result === "error api") {
                    // Handle not logged in or API error
                    // localStorage.clear();
                    // navigate("/login");
                }

                if (result !== false) {
                    // Assuming token and tokenLocal are defined somewhere
                    if (!token && tokenLocal) {
                        // Dispatch action to set user in Redux store
                        dispatch(setUser({ token: tokenLocal, roles: result }));
                    }
                }
            } catch (error) {
                console.error("Error checking login status:", error);
            }
        };
        checkLoginStatus();
    }, []);

    useEffect(() => {
        if (tokenLocal && loggedIn) {
            getUserInfo();
        }
    }, [loggedIn, tokenLocal]);

    useEffect(() => {
        if (loggedIn) {
            getMonthlyScheduleAPI();
            storeEventParameterAPI();
        }
    }, [loggedIn]);

    useEffect(() => {
        if (token && loggedIn !== false) {
            changeForMe(true);
        } else {
            changeForMe(false);
        }
    }, [token]);

    // Countdown timer function
    useEffect(() => {
        const timer = setInterval(() => {
            setResendTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        // Clear interval when component unmounts
        return () => {
            setModal_VerifyShow(false);
            clearInterval(timer);
        };
    }, []);

    return (
        <>
            {
                loading
                    ?
                    <BookingSkt />
                    :
                    <div className="d-flex row pt-3">
                        <StepBreadcrumb step={1}></StepBreadcrumb>

                        {/* Visit Cards */}
                        <div className="col-12 pt-1 px-2">
                            <FloatTitleCard title={"مشخصات مرکز درمانی"}>
                                <div className="col fs-14">
                                    <div className="d-flex">
                                        <div className="card-body px-0 py-2 d-flex flex-row">
                                            {doctorFile ? (
                                                <img
                                                    className="doctor-image-box col col-auto object-fit-cover me-2"
                                                    src={doctorFile}
                                                ></img>
                                            ) : (
                                                <img
                                                    className="doctor-image-box col col-auto object-fit-cover rounded-pill me-2 p-2 background-bootstrap-gray-200"
                                                    src={doctorIcon}
                                                ></img>
                                            )}

                                            <div className="col d-flex flex-column">
                                                <span className="mt-0 mb-1 fs-14 fw-bold color-bootstrap-gray-800">
                                                    {doctorTitle} {doctorFirstName} {doctorLastName}
                                                </span>

                                                <span className="my-0 fs-12 fw-normal color-bootstrap-gray-600">
                                                    {doctorLastDegree}
                                                </span>
                                            </div>
                                            <div
                                                className="position-absolute"
                                                style={{
                                                    left: isMobile ? "8px" : "16px",
                                                    top: isMobile ? "8px" : "16px",
                                                }}
                                            >
                                                <ShareLinkModal
                                                    justIcon={true}
                                                    text={
                                                        (doctorTitle ? doctorTitle + " " : "") +
                                                        doctorFirstName +
                                                        " " +
                                                        doctorLastName
                                                    }
                                                    subtext={doctorLastDegree}
                                                    link={window.location.href}
                                                    name={
                                                        (doctorTitle ? doctorTitle + " " : "") +
                                                        doctorFirstName +
                                                        " " +
                                                        doctorLastName
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex ">
                                        {/* <p className="me-1">مرکز درمانی :</p> */}
                                        <p>
                                            {placeName} {"(دپارتمان " + departmentName + ")"}
                                        </p>
                                    </div>
                                    <div className="d-flex">
                                        {/* <p className="me-1">دپارتمان :</p> */}
                                        {/* <p>{departmentName}</p> */}
                                    </div>
                                    <div className="d-flex">
                                        {/* <p className="me-1 col-auto">آدرس :</p> */}
                                        <p className="line-height18">{address}</p>
                                    </div>
                                    <div className="d-flex">
                                        <p className="me-1 col-auto m-0">تلفن تماس :</p>
                                        {/* <p className="line-height18 m-0">{doctorPhonenumber}</p> */}
                                        <p className="m-0">
                                            {doctorPhonenumber ? doctorPhonenumber : "شماره‌ای ثبت نشده"}
                                        </p>
                                    </div>
                                </div>
                            </FloatTitleCard>
                        </div>

                        {/* User Cards */}
                        <div className="col-12 pt-3 px-2 d-flex">
                            <FloatTitleCard
                                title={"مشخصات مراجعه کننده"}
                                error={
                                    (guestfirstNameError ||
                                        guestlastNameError ||
                                        guestphoneNumberError) &&
                                    !forMe
                                }
                            >
                                <>


                                    {token && loggedIn !== false && (
                                        <div
                                            className="switch-radio rounded-pill p-1 mx-auto d-flex justify-content-center w-fit mb-2 background-bootstrap-gray-200"
                                            role="group"
                                            aria-label="Basic radio toggle button group"
                                        >
                                            <input
                                                type="radio"
                                                className="btn-check "
                                                name="btnradio"
                                                id="btnradio1"
                                                autoComplete="off"
                                                defaultChecked
                                                onChange={(e) => {
                                                    e.target.checked && changeForMe(true);
                                                }}
                                            />
                                            <label
                                                className="btn btn-outline-primary rounded-pill px-5 py-1 fs-12 border-0"
                                                htmlFor="btnradio1"
                                            >
                                                برای خودم
                                            </label>

                                            <input
                                                type="radio"
                                                className="btn-check"
                                                name="btnradio"
                                                id="btnradio2"
                                                autoComplete="off"
                                                onChange={(e) => {
                                                    e.target.checked && changeForMe(false);
                                                }}
                                            />
                                            <label
                                                className="btn btn-outline-primary rounded-pill px-5 py-1 fs-12 border-0"
                                                htmlFor="btnradio2"
                                            >
                                                برای دیگری
                                            </label>
                                        </div>
                                    )}

                                    <div className="row g-3">
                                        <div className="col col-lg-4 col-12">
                                            <input
                                                type="text"
                                                className={`form-control fs-14 ${false ? "border-danger" : ""
                                                    }`}
                                                placeholder="نام مراجعه کننده"
                                                value={forMe ? firstName : guestfirstName}
                                                onChange={(e) => changeFirstName(e.target.value)}
                                                disabled={forMe}
                                            />
                                            {/* Error message for firstName */}
                                            {guestfirstNameError && !forMe && (
                                                <div className="mb-2">
                                                    <span className="text-danger">{guestfirstNameError}</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col col-lg-4 col-12">
                                            <input
                                                type="text"
                                                className={`form-control fs-14 ${false ? "border-danger" : ""
                                                    }`}
                                                placeholder="نام خانوادگی مراجعه کننده"
                                                value={forMe ? lastName : guestlastName}
                                                onChange={(e) => changeLastName(e.target.value)}
                                                disabled={forMe}
                                            />
                                            {/* Error message for lastName */}
                                            {guestlastNameError && !forMe && (
                                                <div className="mb-2">
                                                    <span className="text-danger">{guestlastNameError}</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col col-lg-4 col-12">
                                            <input
                                                type="text"
                                                className={`form-control fs-14 ${false ? "border-danger" : ""
                                                    }`}
                                                placeholder="شماره همراه مراجعه کننده"
                                                value={forMe ? phoneNumber : guestphoneNumber}
                                                onChange={(e) => changePhoneNumber(e.target.value)}
                                                disabled={forMe}
                                            />
                                            {/* Error message for phoneNumber */}
                                            {guestphoneNumberError && !forMe && (
                                                <div className="mb-2">
                                                    <span className="text-danger">
                                                        {guestphoneNumberError}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </>
                            </FloatTitleCard>
                        </div>

                        <div className="col-12 pt-3 px-2 d-flex">
                            <FloatTitleCard
                                title={"صورت حساب"}
                                error={
                                    (guestfirstNameError ||
                                        guestlastNameError ||
                                        guestphoneNumberError) &&
                                    !forMe
                                }
                            >
                                <>
                                    {/* {
                                        (token && loggedIn !== false) ?
                                            <div
                                                className="switch-radio rounded-pill p-1 mx-auto d-flex justify-content-center w-fit mb-2 background-bootstrap-gray-200"
                                                role="group"
                                                aria-label="Basic radio toggle button group"
                                            >
                                            </div>
                                            : null
                                    } */}

                                    <div className="d-flex justify-content-between ">
                                        <p>هزینه خدمت</p>
                                        <p
                                            style={{ color: '#6C757D' }}>
                                            {
                                                doctorTotalAmount ? (doctorTotalAmount).toLocaleString('fa') + ' تومان' : '_'
                                            }
                                        </p>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center">

                                        <div className="d-flex align-items-center">
                                            <p>بیعانه</p>
                                            <img
                                                className="mb-3 mx-1"
                                                style={{ height: '15px', width: '15px' }}
                                                src="./help.png" alt="help"
                                            />
                                        </div>

                                        <p
                                            style={{ color: '#6C757D' }}>
                                            {
                                                doctorDepositAmount ? (doctorDepositAmount.toLocaleString()) + ' تومان' : '_'
                                            }
                                        </p>

                                    </div>

                                    <span className='container-fluid --bs-gray border border-gray border-gray my-2 d-block'></span>

                                    <div className="d-flex justify-content-between mt-4">
                                        <p>مبلغ قابل پرداخت در مطب</p>
                                        <p
                                            style={{ color: '#6C757D' }}>
                                            {
                                                doctorTotalAmount ? ((doctorTotalAmount - doctorDepositAmount).toLocaleString()) + ' تومان' : '_'
                                            }
                                        </p>
                                    </div>

                                </>
                            </FloatTitleCard>
                        </div>

                        {/* Date-time Cards */}
                        <div className="col-12 pt-3 px-2">
                            <FloatTitleCard title={"انتخاب زمان نوبت"} error={dateTimeError}>
                                <div className="col">
                                    <div className="d-flex flex-column">
                                        <p className="fs-14 mb-2">نزدیک ترین نوبت‌های خالی پزشک</p>
                                    </div>
                                    {selectedHour && selectedDay && (
                                        <div className="d-flex  mb-3">
                                            <span>زمان انتخابی شما : </span>
                                            <span className="mx-3">{selectedHour}</span>
                                            <span>{selectedDay}</span>
                                        </div>
                                    )}
                                    <div className="d-flex row form-check ps-0">
                                        {activeFiveTimes &&
                                            Object.values(activeFiveTimes).map((item, index) => (
                                                <div className="col-lg-6 col-12" key={index}>
                                                    <div
                                                        className={`${selectedDay == item.date && selectedHour == item.time
                                                            ? "border-iso-blue-300 input-drop-shadow color-iso-blue-300"
                                                            : "border-gray-300"
                                                            } rounded my-1 ps-32px py-0 d-flex align-items-center`}
                                                        onClick={() => {
                                                            setSelectedHour(item.time);
                                                            setSelectedDay(item.date);
                                                        }}
                                                    >
                                                        {index == 0 ? (
                                                            <input
                                                                className="date-time form-check-input shadow-none my-1"
                                                                type="radio"
                                                                name="exampleRadios"
                                                                id={`exampleRadios${index}`}
                                                                value={`option${index}`}
                                                                defaultChecked
                                                            />
                                                        ) : (
                                                            <input
                                                                className="date-time form-check-input shadow-none my-1"
                                                                type="radio"
                                                                name="exampleRadios"
                                                                id={`exampleRadios${index}`}
                                                                value={`option${index}`}
                                                            // checked={
                                                            //   selectedDay == item.date &&
                                                            //   selectedHour == item.time
                                                            // }
                                                            // onChange={() => {
                                                            //   setSelectedHour(item.time);
                                                            //   setSelectedDay(item.date);
                                                            // }}
                                                            />
                                                        )}
                                                        <label
                                                            className="form-check-label w-100 text-center my-1"
                                                            htmlFor={`exampleRadios${index}`}
                                                        >
                                                            <span className="ms-3">{item.time}</span>
                                                            <span>{item.date}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}

                                        {
                                            !activeFiveTimes && !activeTimes && <span className="text-danger">همه وقت ها پر شده است</span>
                                        }

                                    </div>

                                    {
                                        activeTimes && (
                                            <div className="d-grid">
                                                <button
                                                    type="button"
                                                    className="btn btn-link text-decoration-none "
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#dateTimeModal"
                                                >
                                                    انتخاب زمانی دیگر
                                                </button>
                                            </div>
                                        )
                                    }
                                </div>

                            </FloatTitleCard>
                        </div>

                        {/* Action buttons */}
                        <div className="col-12 pt-3 px-2 mt-4 d-flex">
                            <div className="pe-2 col-6">
                                <button
                                    className="btn btn-primary w-100"
                                    type="button"
                                    disabled={!selectedDay || !selectedHour}
                                    onClick={() => {
                                        StoreData();
                                    }}
                                >
                                    تایید
                                </button>
                            </div>
                            <div className="ps-2 col-6">
                                <div
                                    className="btn btn-gray w-100"
                                    onClick={() => {
                                        navigate(-1); // go to back (history)
                                    }}
                                >
                                    بازگشت
                                </div>
                            </div>
                        </div>

                        {/* Modals */}
                        {/* calendar modal */}
                        <div
                            className="modal fade"
                            id="dateTimeModal"
                            tabIndex="-1"
                            aria-labelledby="dateTimeModalLabel"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="dateTimeModalLabel">
                                            انتخاب زمان
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body p-0">
                                        <div>
                                            <Swiper
                                                slidesPerView={"auto"}
                                                spaceBetween={0}
                                                navigation={true}
                                                autoHeight={true}
                                                modules={[Navigation]}
                                                className="mySwiper px-4 mt-3"
                                            >
                                                <div className="form-check">
                                                    {activeTimes &&
                                                        Object.entries(activeTimes).map(
                                                            ([date, filled], index) => (
                                                                <SwiperSlide key={index} className="py-0">
                                                                    <label
                                                                        key={index}
                                                                        className={`btn rounded-0 pt-1  ${selectedOption == index
                                                                            ? "btn-primary"
                                                                            : "btn-light"
                                                                            }
                              ${activeTimes[date] == "تکمیل" ? " disabled" : ""}
                              `}
                                                                        onClick={() => {
                                                                            if (activeTimes[date] !== "تکمیل") {
                                                                                handleChangeDay(date);
                                                                                // handleChangeOtherDay(date);
                                                                                handleOptionChange(index);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            name="options"
                                                                            autoComplete="off"
                                                                            className="d-none"
                                                                        />
                                                                        {activeTimes[date] == "تکمیل" ? (
                                                                            <div className="d-flex flex-column">
                                                                                <span>تکمیل</span>
                                                                                <span>{date}</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="d-flex flex-column">
                                                                                <span>{days[date]}</span>
                                                                                <span>{date}</span>
                                                                            </div>
                                                                        )}
                                                                    </label>
                                                                </SwiperSlide>
                                                            )
                                                        )}
                                                </div>
                                            </Swiper>

                                            <div className="d-flex row mx-3 mt-3 border-bottom">

                                                <div
                                                    className={`col ${isShiftAvailable('morning') ? 'tw-cursor-pointer' : 'tw-opacity-40 tw-cursor-auto *:tw-cursor-auto'} text-center ${shift === 0 ? "border-bottom border-2 border-primary" : "btn-light"}`}
                                                    onClick={() => isShiftAvailable('morning') && setShift(0)}
                                                >
                                                    <div className="form-check form-check-inline *:tw-cursor-pointer">
                                                        <input
                                                            className="date-time form-check-input d-none"
                                                            type="radio"
                                                            name="flexRadioShift"
                                                            id="flexRadioDefault1"
                                                        />
                                                        <label
                                                            className={`form-check-label ${shift === 0 ? "color-iso-blue-300" : "btn-light"}`}
                                                            htmlFor="flexRadioDefault1"
                                                        >
                                                            صبح
                                                        </label>
                                                    </div>
                                                </div>

                                                <div
                                                    className={`col ${isShiftAvailable('evening') ? 'tw-cursor-pointer' : 'tw-opacity-40 tw-cursor-auto *:tw-cursor-auto'} text-center ${shift === 1 ? "border-bottom border-2 border-primary" : "btn-light"}`}
                                                    onClick={() => isShiftAvailable('evening') && setShift(1)}
                                                >
                                                    <div className="form-check form-check-inline *:tw-cursor-pointer col">
                                                        <input
                                                            className="date-time form-check-input d-none"
                                                            type="radio"
                                                            name="flexRadioShift"
                                                            id="flexRadioDefault2"
                                                        />
                                                        <label
                                                            className={`form-check-label ${shift === 1 ? "color-iso-blue-300" : "btn-light"
                                                                }`}
                                                            htmlFor="flexRadioDefault2"
                                                        >
                                                            ظهر
                                                        </label>
                                                    </div>
                                                </div>

                                                <div
                                                    className={`col ${isShiftAvailable('night') ? 'tw-cursor-pointer' : 'tw-opacity-40 tw-cursor-auto *:tw-cursor-auto'} text-center ${shift === 2 ? "border-bottom border-2 border-primary" : "btn-light"}`}
                                                    onClick={() => isShiftAvailable('night') && setShift(2)}
                                                >
                                                    <div className="form-check form-check-inline *:tw-cursor-pointer col">
                                                        <input
                                                            className="date-time form-check-input d-none"
                                                            type="radio"
                                                            name="flexRadioShift"
                                                            id="flexRadioDefault3"
                                                        />
                                                        <label
                                                            className={`form-check-label ${shift === 2 ? "color-iso-blue-300" : "btn-light"}`}
                                                            htmlFor="flexRadioDefault3"
                                                        >
                                                            شب
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="d-flex row mx-2 mt-1 justify-content-center">
                                                {hours &&
                                                    hours.map((hours, index) => (
                                                        <div
                                                            key={index}
                                                            className="col col-auto mx-2 my-1 px-0 d-flex justify-content-center"
                                                        >
                                                            <button
                                                                type="button"
                                                                disabled={isActive(shift, hours)}
                                                                className={`btn  time-col rounded-pill border-1  px-2 py-0 ${selectedHour == hours
                                                                    ? "btn-light color-bootstrap-regular-secondary border-bootstrap-gray-400"
                                                                    : ""
                                                                    }`}
                                                                onClick={(e) => {
                                                                    handleChangeHour(hours);
                                                                    // handleChangeOtherHour(hours);
                                                                }}
                                                            >
                                                                <span>{hours.substring(0, 5)}</span>
                                                            </button>
                                                        </div>
                                                    ))}
                                            </div>
                                            <hr />

                                            <div className="d-flex row mx-3 my-3 justify-content-center">
                                                <div
                                                    className={`btn btn-primary ${selectedDay && selectedHour ? "" : "disabled"
                                                        }`}
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                >
                                                    تایید
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* verification modal */}
                        <div
                            className={`modal fade${modal_VerifyShow ? " show d-block" : ""}`}
                            id="twoFAModal"
                            aria-hidden="true"
                            aria-labelledby="exampleModalToggleLabel"
                            tabIndex="-1"
                        >
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalToggleLabel">
                                            ثبت نهایی نوبت شماره {modal_VerifyInfo.eventId}
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            aria-label="Close"
                                            onClick={() => {
                                                setModal_VerifyShow(false);
                                                setVerifyHeaders({
                                                    Authorization: null,
                                                });
                                                getMonthlyScheduleAPI();
                                            }}
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <p className="fs-12">
                                            کد 4 رقمی به شماره {guestphoneNumber} ارسال شد.
                                        </p>
                                        <form onSubmit={Verify} className="d-flex flex-column">
                                            <input
                                                type="number"
                                                className="form-control mb-2"
                                                placeholder="1234"
                                                value={modal_VerifyInfo.code}
                                                onChange={(e) => {
                                                    setModal_VerifyInfo((prevState) => ({
                                                        ...prevState,
                                                        code: e.target.value,
                                                    }));
                                                }}
                                                autoFocus
                                            />
                                            <span>
                                                {resendTimer > 0
                                                    ? `مهلت تایید نهایی نوبت (تا ${convertSecondsToMinutesAndSeconds(
                                                        resendTimer
                                                    )})`
                                                    : "نوبت شما لغو شد"}
                                            </span>

                                            <button
                                                className="btn btn-primary col-6"
                                                type="submit"
                                                disabled={
                                                    loading ||
                                                    !modal_VerifyInfo.code ||
                                                    !modal_VerifyInfo.eventId ||
                                                    resendTimer == 0
                                                }
                                                onClick={Verify}
                                            >
                                                ثبت نهایی نوبت
                                                {loading && (
                                                    <span
                                                        className="spinner-border spinner-border-sm ms-1"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`fade${modal_VerifyShow ? " modal-backdrop show" : ""}`}
                            onClick={() => {
                                setModal_VerifyShow(false);
                                setVerifyHeaders({ Authorization: null });
                            }}
                        />
                    </div>
            }
        </>

    );
};

export default ActiveTimesByPlace;
